import React, { useState, useEffect } from 'react';
import { Switch, Route, RouteProps, Redirect } from 'react-router-dom';
// import { LogIn } from './auth/LogIn';
// import { SignUp } from './auth/SignUp';
// import { ResetCredentials } from './auth/ResetCredentials';
import { NoPageFound } from './shared/NoPageFound';
import { PageRoutes } from '../conf/Global';
import { checkAuthStatusFromServer } from './auth/checkAuthStatus';
import { useTrackPageView } from './analytics';
import { ProtectedRoutes } from './ProtectedRoutes';
import { SplashScreen } from './shared/SplashScreen';

const ProtectedRoute: React.FC<RouteProps> = ({ ...props }) => {
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const currentPath = window.location.pathname + window.location.search;

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const { isAuthenticated } = await checkAuthStatusFromServer();

                // If user is NOT authenticated, redirect to authenticate page
                if (!isAuthenticated) {
                    setShouldRedirect(true);
                    // Before redirecting to /authenticate route, we need to clear the local storage
                    localStorage.clear();
                }
            } catch (error) {
                console.error('Authentication check failed:', error);
                setShouldRedirect(true);
                localStorage.clear();
            } finally {
                setIsCheckingAuth(false);
            }
        };

        checkAuth();
    }, []);

    // Show loading state while checking authentication
    if (isCheckingAuth) {
        return <SplashScreen />;
    }

    // Redirect if authentication failed
    if (shouldRedirect) {
        window.location.replace(`${PageRoutes.AUTHENTICATE}?redirect_uri=${encodeURIComponent(currentPath)}`);
        return null;
    }

    return <Route {...props} />;
};

/**
 * Container for all top-level routes.
 */
export const Routes = (): JSX.Element => {
    useTrackPageView();

    return (
        <Switch>
            {/* Disabling the routes, as these routes are not needed for Data Catalog */}
            {/* <Route path={PageRoutes.LOG_IN} component={LogIn} /> */}
            {/* <Route path={PageRoutes.SIGN_UP} component={SignUp} /> */}
            {/* <Route path={PageRoutes.RESET_CREDENTIALS} component={ResetCredentials} /> */}

            <ProtectedRoute render={() => <ProtectedRoutes />} />
            {/* Starting the react app locally opens /assets by default. For a smoother dev experience, we'll redirect to the homepage */}
            <Route path={PageRoutes.ASSETS} component={() => <Redirect to="/" />} exact />
            <Route path="/*" component={NoPageFound} />
        </Switch>
    );
};
